import { t } from "i18next";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { ZRole } from "src/types";

import { columnDisplayId, sysColumnsHistory } from "../sysData/sysColumns";

export const makeRolesColumns = (): RtColumn<ZRole>[] => [
  columnDisplayId,
  {
    key: "name",
    title: t("Name"),
    width: 200,
    render: (row: ZRole) => row.name,
  },
  {
    key: "description",
    title: t("Description"),
    width: 300,
    render: (row: ZRole) => row.description || "-",
  },
  ...sysColumnsHistory,
];
